import { render, staticRenderFns } from "./methodPrice.vue?vue&type=template&id=85da599a&scoped=true&"
import script from "./methodPrice.vue?vue&type=script&lang=js&"
export * from "./methodPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da599a",
  null
  
)

export default component.exports